/**
 * Service Level Objective Endpoints
 */

export const apiPostServiceLevelObjective = async (
  serviceLevelObjective: ServiceLevelObjectiveCreateUpdate,
): Promise<AxiosResponse<ServiceLevelObjective>> => {
  return await userManagementAxiosInstance.post('service_level_objectives', serviceLevelObjective);
};

export const apiGetServiceLevelObjectives = async (
  limit: number = defaultLimit,
  offset: number = defaultOffset,
  search: string = '',
): Promise<AxiosResponse<PaginatedServiceLevelObjective>> => {
  return await userManagementAxiosInstance.get(
    `service_level_objectives?limit=${limit}&offset=${offset}&name=${search}`,
  );
};

export const apiGetServiceLevelObjective = async (
  id: string | number,
): Promise<AxiosResponse<ServiceLevelObjective>> => {
  return await userManagementAxiosInstance.get(`service_level_objectives/${id}`);
};

export const apiPutServiceLevelObjective = async (
  serviceLevelObjective: ServiceLevelObjectiveCreateUpdate,
): Promise<AxiosResponse<ServiceLevelObjective>> => {
  return await userManagementAxiosInstance.put(
    `service_level_objectives/${serviceLevelObjective.id}`,
    serviceLevelObjective,
  );
};

export const apiDeleteServiceLevelObjective = async (
  id: string | number,
): Promise<AxiosResponse<ServiceLevelObjective>> => {
  return await userManagementAxiosInstance.delete(`service_level_objectives/${id}`);
};
